module.exports = __webpack_public_path__ + "img/b5-4.fa14276.png";